<template>
  <div class="page-container">
    <div class="detail-card">
      <div class="page-header">
        <span class="page-title">登入紀錄詳情</span>
      </div>
      
      <div class="card-content">
        <div v-if="loginLog" class="detail-content">
          <div class="section">
            <h3 class="section-title">基本資訊</h3>
            <div class="info-grid">
              <div class="info-item">
                <label>用戶：</label>
                <span>{{ loginLog.user_name }}</span>
              </div>
              <div class="info-item">
                <label>登入時間：</label>
                <span>{{ formatDateTime(new Date(loginLog.login_time)) }}</span>
              </div>
              <div class="info-item">
                <label>登出時間：</label>
                <span v-if="loginLog.logout_time">{{ formatDateTime(new Date(loginLog.logout_time)) }}</span>
                <span v-else class="active-status">登入中</span>
              </div>
              <div class="info-item">
                <label>會話時長：</label>
                <span v-if="loginLog.session_duration">{{ loginLog.session_duration }}分鐘</span>
                <span v-else>-</span>
              </div>
              <div class="info-item">
                <label>IP地址：</label>
                <span>{{ loginLog.ip_address || '未知' }}</span>
              </div>
              <div class="info-item">
                <label>用戶代理：</label>
                <span class="user-agent">{{ loginLog.user_agent || '未知' }}</span>
              </div>
            </div>
          </div>

          <div v-if="loginLog.device_info" class="section">
            <h3 class="section-title">裝置資訊</h3>
            <div class="device-info-grid">
              <div class="device-row">
                <div class="device-item">
                  <label>品牌：</label>
                  <span>{{ loginLog.device_info.manufacturer || '未知' }}</span>
                </div>
                <div class="device-item">
                  <label>型號：</label>
                  <span>{{ loginLog.device_info.model || '未知' }}</span>
                </div>
              </div>
              <div class="device-row">
                <div class="device-item">
                  <label>平台：</label>
                  <span>{{ loginLog.device_info.platform || '未知' }}</span>
                </div>
                <div class="device-item">
                  <label>版本：</label>
                  <span>{{ loginLog.device_info.os_version || '未知' }}</span>
                </div>
              </div>
              <div class="device-row">
                <div class="device-item">
                  <label>裝置名稱：</label>
                  <span>{{ loginLog.device_info.device_name || '未知' }}</span>
                </div>
                <div class="device-item">
                  <label>產品名稱：</label>
                  <span>{{ loginLog.device_info.product_name || '未知' }}</span>
                </div>
              </div>
              <div class="device-row">
                <div class="device-item">
                  <label>WiFi IP：</label>
                  <span>{{ loginLog.device_info.wifi_ip || '未知' }}</span>
                </div>
                <div class="device-item">
                  <label>WiFi MAC：</label>
                  <span>{{ loginLog.device_info.wifi_mac || '未知' }}</span>
                </div>
              </div>
              <div class="device-row">
                <div class="device-item">
                  <label>裝置 ID：</label>
                  <span>{{ loginLog.device_info.device_id || '未知' }}</span>
                </div>
                <div class="device-item">
                  <label>裝置 UUID：</label>
                  <span class="uuid-text">{{ loginLog.device_info.device_uuid || '未知' }}</span>
                </div>
              </div>
              <div class="device-row">
                <div class="device-item">
                  <label>Build ID：</label>
                  <span>{{ loginLog.device_info.build_id || '未知' }}</span>
                </div>
                <div class="device-item">
                  <label>SDK 版本：</label>
                  <span>{{ loginLog.device_info.sdk_version || '未知' }}</span>
                </div>
              </div>
              <div class="device-row">
                <div class="device-item">
                  <label>硬體：</label>
                  <span>{{ loginLog.device_info.hardware || '未知' }}</span>
                </div>
                <div class="device-item">
                  <label>實體裝置：</label>
                  <span>{{ loginLog.device_info.is_physical_device ? '是' : '否' }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 無裝置資訊提示 -->
          <div v-else class="section">
            <h3 class="section-title">裝置資訊</h3>
            <div class="no-device-info">
              此登入紀錄無裝置資訊
            </div>
          </div>
        </div>

        <div v-else-if="loading" class="loading">
          <a-spin size="large" />
          <p>載入中...</p>
        </div>

        <div v-else-if="error" class="error">
          <a-result
            status="error"
            title="載入失敗"
            :sub-title="error"
          >
            <template #extra>
              <a-button type="primary" @click="fetchData">重試</a-button>
            </template>
          </a-result>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LoginLogDetailPage',
  data() {
    return {
      loginLog: null,
      loading: true,
      error: null
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.error = null;
      
      const token = localStorage.getItem('token');
      const logId = this.$route.params.logId;
      
      this.$axios.get(`/api/login-logs/${logId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(response => {
        this.loginLog = response.data.data;
        this.loading = false;
      }).catch(error => {
        console.error(error);
        this.loading = false;
        if (error.response && error.response.status === 403) {
          this.error = '權限不足，無法查看此登入紀錄';
        } else if (error.response && error.response.status === 404) {
          this.error = '登入紀錄不存在';
        } else {
          this.error = '載入失敗，請稍後重試';
        }
      });
    },
    formatDateTime(date) {
      try {
        return new Intl.DateTimeFormat("zh-TW", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit"
        }).format(date);
      } catch (e) {
        return "";
      }
    }
  }
};
</script>

<style scoped>
.page-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.detail-card {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 1000px;
}

.page-header {
  display: flex;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
}

.page-title {
  font-size: 20px;
  font-weight: 500;
  margin-left: 16px;
}

.card-content {
  padding: 24px;
}

.section {
  margin-bottom: 32px;
}

.section-title {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.info-item {
  display: flex;
  align-items: center;
  padding: 12px;
  background-color: #fafafa;
  border-radius: 6px;
}

.info-item label {
  font-weight: 500;
  color: #666;
  min-width: 80px;
  margin-right: 12px;
}

.info-item span {
  color: #333;
  flex: 1;
}

.active-status {
  color: #52c41a;
  font-weight: 500;
}

.user-agent {
  font-family: monospace;
  font-size: 12px;
  word-break: break-all;
}

.device-info-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.device-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.device-item {
  display: flex;
  align-items: center;
  padding: 12px;
  background-color: #fafafa;
  border-radius: 6px;
}

.device-item label {
  font-weight: 500;
  color: #666;
  min-width: 100px;
  margin-right: 12px;
}

.device-item span {
  color: #333;
  flex: 1;
}

.uuid-text {
  font-family: monospace;
  font-size: 12px;
  word-break: break-all;
}

.no-device-info {
  text-align: center;
  color: #999;
  padding: 32px;
  font-style: italic;
  background-color: #fafafa;
  border-radius: 6px;
}

.loading {
  text-align: center;
  padding: 60px 20px;
}

.loading p {
  margin-top: 16px;
  color: #666;
}

.error {
  padding: 40px 20px;
}
</style>
